<template>
    <div class="container" style="padding-top: 10px" v-show="shop.provider_id">
        <div class="el-card box-card is-always-shadow">
            <div class="el-card__header">
                <div class="clearfix text-bold">
                    <span>Ordenes por Cuotas</span>
                </div>
            </div>
            <form :model="form" label-width="120px" @submit.prevent="onSubmit">
                <div class="el-card__body" v-show="step == 1">
                    <div class="row">
                        <div class="col-md-12">
                            <img
                                class="profile-user-img img-responsive img-circle"
                                v-bind:src="avatar"
                                alt="User profile picture"
                            />
                            <h3 class="profile-username text-center">
                                {{ employee.profiles.first_name }}
                                {{ employee.profiles.first_surname }}
                                {{ employee.profiles.second_surname }}
                            </h3>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group text-left">
                                <label>Cédula</label>
                                <input
                                    class="form-control"
                                    v-validate="'required'"
                                    name="identification"
                                    type="text"
                                    v-model.trim="form.identification"
                                    autocomplete="off"
                                    required
                                />
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="msolicitado"
                                    >Monto a Facturar {{ form.subtotal }}</label
                                >
                                <input
                                    type="text"
                                    class="form-control"
                                    id="msolicitado"
                                    aria-describedby="msolicitadoH"
                                    placeholder="0.00"
                                    v-model="form.subtotal"
                                />
                                <small
                                    id="msolicitadoH"
                                    class="form-text text-muted"
                                    >Monto a solicitar por la oferta. Monto
                                    maximo de credito
                                    {{ availableAmount }}.</small
                                >
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="msavan">Monto Avance</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="msavan"
                                    aria-describedby="msavanH"
                                    placeholder="0.00"
                                    v-model="form.invoice_payment"
                                    :max="form.subtotal"
                                />
                                <small id="msavanH" class="form-text text-muted"
                                    >Monto pagado por el cliente.</small
                                >
                            </div>
                        </div>
                        <div class="col-md-12" v-show="form.discount">
                            <div class="form-group">
                                <label for="msavan">Subsidio</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="msavan"
                                    aria-describedby="msavanH"
                                    placeholder="0.00"
                                    v-model="form.discount"
                                    disabled
                                />
                                <small id="msavanH" class="form-text text-muted"
                                    >Monto pagado por la empresa del
                                    empleado.</small
                                >
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="tinteres">Oferta (Opcional)</label>
                                <select
                                    v-model="form.offer_id"
                                    class="form-control"
                                >
                                    <option value="1" selected="selected">
                                        No lleva oferta.
                                    </option>
                                    <option
                                        v-for="offer in offers"
                                        v-bind:value="offer.id"
                                    >
                                        {{ offer.title }}
                                    </option>
                                </select>
                                <small
                                    id="tinteresH"
                                    class="form-text text-muted"
                                    >Oferta seleccionada.</small
                                >
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="checkbox">
                                <label>
                                    <input
                                        type="checkbox"
                                        v-model="form.itbis"
                                    />
                                    Los precios ya incluyen ITBIS?
                                </label>
                            </div>
                            <div class="checkbox" v-show="form.discount">
                                <label>
                                    <input
                                        type="checkbox"
                                        v-model="form.apply_subsidy"
                                    />
                                    Aplicar Subsidio?
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="text-right">
                        <el-button type="danger" @click="resetForm"
                            >Cancelar</el-button
                        >
                        <el-button
                            type="primary"
                            @click="next(2)"
                            :disabled="employee.profiles.first_name.length < 1"
                        >
                            Continuar
                        </el-button>
                    </div>
                </div>
                <div class="el-card__body" v-show="step == 2">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="msolicitado"
                                    >Monto a Facturar</label
                                >
                                <input
                                    type="text"
                                    class="form-control"
                                    id="msolicitado"
                                    aria-describedby="msolicitadoH"
                                    placeholder="0.00"
                                    v-model="form.subtotal"
                                    :disabled="true"
                                />
                                <small
                                    id="msolicitadoH"
                                    class="form-text text-muted"
                                    >Monto a solicitar por la oferta.</small
                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="msavan">Monto Avance</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="msavan"
                                    aria-describedby="msavanH"
                                    placeholder="0.00"
                                    v-model="form.invoice_payment"
                                    :max="form.subtotal"
                                    :disabled="true"
                                />
                                <small id="msavanH" class="form-text text-muted"
                                    >Monto pagado por el cliente.</small
                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="Dues">Cuotas Quincenales</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="Dues"
                                    aria-describedby="duesH"
                                    placeholder="12"
                                    v-model="form.total_splits"
                                    :min="minSplits"
                                    :max="maxSplits"
                                />
                                <small id="duesH" class="form-text text-muted"
                                    >Cantidad de cuotas para pagar la oferta.
                                    Cantidad minima ({{ minSplits }}), Cantidad
                                    maxima ({{ maxSplits }}).
                                </small>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="tinteres">Cargo total</label>
                                <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    id="tinteres"
                                    aria-describedby="tinteresH"
                                    placeholder="0.00"
                                    v-model="form.interest_amount"
                                />
                                <small
                                    id="tinteresH"
                                    class="form-text text-muted"
                                    >Cantidad de interes a pagar al final del
                                    prestamo.</small
                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="nDues">Próximo descuento</label>
                                <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    id="nDues"
                                    aria-describedby="nduesH"
                                    placeholder="0.00"
                                    v-model="form.next_due"
                                />
                                <small id="nduesH" class="form-text text-muted"
                                    >Cantidad a descontar en la proxima
                                    quincena.</small
                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="total">Total a facturar</label>
                                <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    id="total"
                                    aria-describedby="totalh"
                                    placeholder="0.00"
                                    v-model="form.total"
                                />
                                <small id="totalh" class="form-text text-muted"
                                    >Monto total del prestamo.</small
                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group text-left">
                                <label> Código de empleado </label>
                                <input
                                    v-model="form.code"
                                    type="password"
                                    name="code"
                                    autocomplete="off"
                                    required="required"
                                    class="form-control"
                                    aria-required="true"
                                    aria-invalid="false"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="text-right">
                        <el-button type="danger" @click="resetForm"
                            >Cancelar</el-button
                        >
                        <el-button
                            type="primary"
                            @click="onSubmit"
                            :disabled="isLoading"
                        >
                            Continuar
                        </el-button>
                    </div>
                </div>
            </form>
            <div class="el-card__body" v-show="step == 3">
                <table>
                    <tr>
                        <td class="td-lable">Cliente:</td>
                        <td class="td-data">{{ respomse.client }}</td>
                    </tr>
                    <tr>
                        <td class="td-lable">Subtotal:</td>
                        <td class="td-data">
                            {{ respomse.subtotal | currency }}
                        </td>
                    </tr>
                    <tr>
                        <td class="td-lable">ITBIS:</td>
                        <td class="td-data">{{ respomse.tax | currency }}</td>
                    </tr>
                    <tr>
                        <td class="td-lable">Total Facturado:</td>
                        <td class="td-data">
                            {{ (respomse.subtotal + respomse.tax) | currency }}
                        </td>
                    </tr>
                    <tr>
                        <td class="td-lable">Monto Avance:</td>
                        <td class="td-data">
                            {{ respomse.request.invoice_payment | currency }}
                        </td>
                    </tr>
                    <tr>
                        <td class="td-lable">Subsidio:</td>
                        <td class="td-data">
                            {{ respomse.request.discount | currency }}
                        </td>
                    </tr>
                    <tr>
                        <td class="td-lable">Saldo Pendiente:</td>
                        <td class="td-data">
                            {{
                                (respomse.subtotal +
                                    respomse.tax -
                                    respomse.request.invoice_payment)
                                    | currency
                            }}
                        </td>
                    </tr>
                    <tr>
                        <td class="td-lable">Cantidad de Cuotas:</td>
                        <td class="td-data">
                            {{ respomse.request.total_splits }}
                        </td>
                    </tr>
                    <tr>
                        <td class="td-lable">Próximo descuento:</td>
                        <td class="td-data">
                            {{ respomse.request.next_due | currency }}
                        </td>
                    </tr>
                    <tr>
                        <td class="td-lable">Total a Pagar:</td>
                        <td class="td-data">
                            {{ respomse.request.total | currency }}
                        </td>
                    </tr>
                </table>
                <div class="text-right">
                    <el-button type="primary" @click="resetForm">
                        Nueva Orden
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

// Interes de CashMarket: 2% por cuota sobre el saldo, amortizacion nivelada.
// Debe seguir a Employees::CASH_MARKET_INTEREST_RATE en cdi-api, que es quien
// manda a la hora de registrar la orden.
const CASH_MARKET_INTEREST_RATE = 0.02;

const round2 = (n) => Math.round(n * 100) / 100;

/**
 * Tabla de amortizacion nivelada. Replica LoanAmortization::schedule() de
 * cdi-api: cada periodo se recalcula sobre el saldo y el plazo restante, y el
 * residuo del redondeo se carga a la ultima cuota. Tiene que dar exactamente lo
 * mismo que la API, porque lo que se muestra aca es lo que se va a facturar.
 */
function amortizationSchedule(loanAmount, interest, terms) {
    terms = terms < 1 ? 1 : terms;
    loanAmount = round2(loanAmount);

    if (loanAmount <= 0) {
        return Array.from({ length: terms }, () => ({
            principal: 0,
            interest: 0,
            total: 0,
        }));
    }

    const schedule = [];
    let balance = loanAmount;
    let remaining = terms;
    let principalSum = 0;

    for (let i = 0; i < terms; i++) {
        const payment =
            balance * (interest / (1 - Math.pow(1 + interest, -remaining)));
        const periodInterest = balance * interest;
        const principal = payment - periodInterest;

        balance = balance - principal;
        remaining--;

        const roundedPrincipal = round2(principal);
        schedule.push({
            principal: roundedPrincipal,
            interest: round2(periodInterest),
        });
        principalSum = round2(principalSum + roundedPrincipal);
    }

    const last = terms - 1;
    schedule[last].principal = round2(
        schedule[last].principal + (loanAmount - principalSum)
    );

    schedule.forEach((row) => {
        row.total = round2(row.principal + row.interest);
    });

    return schedule;
}

export default {
    name: "dues",
    components: {},
    data() {
        return {
            step: 1,
            respomse: {
                transactions: {
                    id: "",
                },
                request: {
                    identification: "",
                    total_splits: "",
                    next_due: "",
                    total: "",
                },
                client: "",
                subtotal: "",
                tax: "",
            },
            offers: {},
            shop: {},
            incomeAmount: null,
            minSplits: 1,
            maxSplits: 1,
            availableAmount: 0,
            avatar: "https://via.placeholder.com/150",
            employee: {
                profiles: {
                    first_name: "",
                    first_surname: "",
                    second_surname: "",
                },
            },
            form: {
                identification: "",
                total_splits: 1,
                subtotal: "",
                shop_id: "",
                code: "",
                date: moment().format("YYYY-MM-DD"),
                employee_id: "",
                total: 0,
                status: 0,
                invoice_payment: 0,
                itbis: true,
                next_due: 0,
                interest_amount: 0,
                provider_id: 0,
                discount: 0,
                offer_id: 1,
                apply_subsidy: 1,
            },
            isLoading: false,
            labels: {
                identification: "Cedula",
                total_splits: "Cuotas",
                subtotal: "Monto a Facturar",
                shop_id: "Codigo de tienda",
                code: "codigo de empleado",
                date: "fecha",
                employee_id: "Empleado",
                interest_amount: "Cargo",
                total: "total",
                next_due: "Próximo descuento",
            },
        };
    },
    async created() {
        this.getShops();
        this.getOffers();
    },
    watch: {
        "form.apply_subsidy": function (val) {
            if (!val) {
                this.form.discount = 0;
            }
            this.cal();
        },
        "form.total_splits": function (val) {
            this.cal();
        },
        "form.subtotal": function (val) {
            this.subtotalCal();
            this.cal();

            if (parseInt(val) <= 0) return;

            this.getDiscount({
                employee_id: this.form.employee_id,
                shop_id: this.$store.state.user.id,
                subtotal: val,
            });
        },
        "form.itbis": function (val) {
            this.cal();
        },
        "form.invoice_payment": function (val) {
            this.subtotalCal();
            this.cal();
        },
        "form.identification": function (val) {
            if (this.form.identification.length > 5) {
                this.getUser();
                this.getCreditLimit();
            } else {
                this.setProfileNull();
            }
        },
    },
    methods: {
        subtotalCal() {
            // El tope de credito para empleados con menos de 90 dias lo resuelve
            // la API en /employees/{id}/limit (ver
            // Employees::CASH_MARKET_NEW_HIRE_SHOP_ALLOWANCE). Antes esto era un
            // hardcode de 3000 para company_id 49 que ademas tiraba un TypeError
            // cuando todavia no habia empleado cargado, y se llevaba consigo al
            // cal() que viene despues en el watcher.
            if (this.form.subtotal > this.availableAmount) {
                this.form.subtotal = this.availableAmount;
            }
            var amount = this.form.subtotal;
            if (this.form.itbis == false) {
                amount = this.form.subtotal * 1.18;
            }

            amount = amount - this.form.invoice_payment - this.form.discount;

            if (amount > 0) {
                axios
                    .get(
                        `${API_URL}/products/super-market/splits/${amount}/${this.form.employee_id}`
                    )
                    .then(({ data }) => {
                        if (data) {
                            this.minSplits = data.min_split;
                            this.maxSplits = data.max_split;
                            this.form.total_splits = this.minSplits;
                        }
                    });
                // .catch((e) => {});
            } else {
                this.minSplits = 1;
                this.maxSplits = 1;
                this.form.total_splits = 1;
            }
        },
        setProfileNull() {
            this.employee.profiles.first_name = "";
            this.employee.profiles.first_surname = "";
            this.employee.profiles.second_surname = "";
            this.avatar = "https://via.placeholder.com/150";
        },
        getUser() {
            axios
                .get(
                    `${API_URL}/users?q=(identification:${this.form.identification})&relationships=profiles,employees`
                )
                .then(({ data }) => {
                    if (data.length >= 1) {
                        this.employee = data[0];
                        this.form.employee_id = this.employee.employees.id;
                        this.avatar =
                            "https://app.cashdepotint.com/avatars/" +
                            this.employee.employees.id +
                            ".jpg";
                        this.getDiscount({
                            employee_id: this.form.employee_id,
                            shop_id: this.$store.state.user.id,
                            subtotal: 0,
                        });
                    } else {
                        this.setProfileNull();
                    }
                });
        },
        getOffers() {
            axios
                .get(
                    `${API_URL}/offers?q=(provider_id:${this.shop.provider_id},status_id:1)`
                )
                .then(({ data }) => {
                    this.offers = data;
                });
        },
        cal() {
            if (!this.form.employee_id) {
                return;
            }
            // Mismo principal financiado que usa la API en
            // OrdersController::processDues: se sube el ITBIS primero y recien
            // ahi se restan el avance y el subsidio. Antes la rama de ITBIS
            // sobrescribia amount y se comia esos dos descuentos.
            var subtotal = Number(this.form.subtotal) || 0;
            if (this.form.itbis == false) {
                subtotal = subtotal * 1.18;
            }

            var amount =
                subtotal -
                (Number(this.form.invoice_payment) || 0) -
                (Number(this.form.discount) || 0);

            if (amount < 0) {
                amount = 0;
            }

            var total_splits = Number(this.form.total_splits) || 1;
            if (total_splits < 1) {
                total_splits = 1;
            }

            // El interes sale de la tabla de amortizacion, no de shop.charge:
            // esa columna viene en 0/NULL para casi todas las tiendas y dejaba
            // la venta sin cargo en pantalla mientras la API si lo facturaba.
            const schedule = amortizationSchedule(
                amount,
                CASH_MARKET_INTEREST_RATE,
                total_splits
            );

            this.form.interest_amount = schedule.reduce(
                (sum, row) => round2(sum + row.interest),
                0
            );
            // La cuota es la primera fila de la tabla, no el total dividido: al
            // reves (total = cuota redondeada x cuotas) se perdian centavos.
            this.form.next_due = schedule[0].total;
            this.form.total = round2(amount + this.form.interest_amount);

            this.incomeAmount = this.form.total;

            // if(this.availableAmount < amount){
            //      if(this.form.itbis == false){
            //         this.form.subtotal = Number((this.availableAmount / 1.18).toFixed(2));
            //     }else{
            //         this.form.subtotal = Number(this.availableAmount.toFixed(2));
            //     }
            // }
        },
        async onSubmit() {
            this.isLoading = true;
            if (!this.shop.id) {
                this.isLoading = false;
                return;
            }

            const formData = Object.entries(this.form);

            if (
                formData.some((entry) => {
                    if (
                        !entry[1] &&
                        entry[0] != "status" &&
                        entry[0] != "itbis" &&
                        entry[0] != "offer_id" &&
                        entry[0] != "invoice_payment" &&
                        entry[0] != "discount" &&
                        entry[0] != "total" &&
                        entry[0] != "next_due" &&
                        entry[0] != "apply_subsidy" &&
                        entry[0] != "interest_amount"
                    ) {
                        const label = this.labels[entry[0]] || entry[0];
                        this.$notify({
                            title: "Error",
                            message: `el campo: ${label} es requerido`,
                            type: "error",
                        });
                        this.isLoading = false;
                        return !entry[1];
                    }
                })
            ) {
                return;
            }

            if (this.form.total_splits < this.minSplits) {
                this.$notify({
                    title: "Error",
                    message: `La cantidad de cuotas no es valida la cantida minima es de ${this.minSplits}`,
                    type: "error",
                });
                this.isLoading = false;
                return;
            }

            if (this.form.total_splits > this.maxSplits) {
                this.$notify({
                    title: "Error",
                    message: `La cantidad de cuotas no es valida la cantida maxima es de ${this.maxSplits}`,
                    type: "error",
                });
                this.isLoading = false;
                return;
            }

            axios
                .post(`${API_URL}/orders/dues`, this.form)
                .then(({ data }) => {
                    this.onOrderSucess(data);
                })
                .catch((error) => {
                    var message = error.response.data.status.message;
                    this.$notify({
                        title: "Error",
                        message: message,
                        type: "error",
                    });
                    this.isLoading = false;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getShops() {
            this.shop = this.$store.state.user;
            this.form.shop_id = this.$store.state.user.id;
            this.form.subtotal = 0;
            this.form.total = 0;
            this.form.provider_id = this.$store.state.user.provider_id;
        },
        next(s) {
            this.step = s;
        },

        getCreditLimit() {
            if (!this.form.identification) {
                return;
            }

            const amount = this.form.subtotal;
            // shop_id es necesario para que la API pueda aplicar el piso de
            // credito de empleados nuevos, que se define por tienda.
            axios
                .get(
                    `${API_URL}/employees/${this.form.identification}/limit?shop_id=${this.form.shop_id}`
                )
                .then(({ data }) => {
                    if (data) {
                        this.incomeAmount = data.balance[3] * 1;
                        this.availableAmount = data.limit_of_credit * 1;
                        this.minSplits = Math.ceil(
                            amount / data.maximum_discount[3]
                        );
                        this.form.employee_id = data.employee_id;
                        this.form.total_splits.minSplits = this.minSplits * 1;
                    }
                })
                .catch((e) => {});
        },

        onOrderSucess(order) {
            this.respomse = order;
            this.respomse.client =
                this.employee.profiles.first_name +
                " " +
                this.employee.profiles.first_surname +
                " " +
                this.employee.profiles.second_surname;

            if (this.form.itbis) {
                this.respomse.subtotal = this.form.subtotal / 1.18;
                this.respomse.tax = this.form.subtotal - this.respomse.subtotal;
            } else {
                this.respomse.subtotal = this.form.subtotal * 1;
                this.respomse.tax = this.form.subtotal * 0.18;
            }
            this.step = 3;

            this.$notify({
                title: "Orden agregada",
                message: "Orden procesada correctamente.",
                type: "sucess",
            });
        },
        resetForm() {
            location.reload();
        },
        getDiscount(orderData) {
            axios
                .post(`${API_URL}/orders/get-discount`, orderData)
                .then(({ data }) => {
                    this.form.discount = Number(data || 0);
                })
                .catch(() => {
                    this.form.discount = 0;
                });
        },
    },
};
</script>
